import { useNavigationStore } from "presentation/mobile/stores/navigation-store";
import { useEffect } from "react";
import TaskToApprovalList from "presentation/mobile/components/Documents/TaskToApprovalList";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import TaskToApprovalListSkeleton from "presentation/mobile/components/Documents/TaskToApprovalList/Skeleton";

const FUNCTION = "approve-documents";
const REQUIRE_FUNCTION = 'dashboards'
const LEVEL = 1;

const ApproveDocuments = () => {

    const {isLoading, hasPermission} = usePermissionCheck({requiredFunction: REQUIRE_FUNCTION});

    const navigationState = useNavigationStore();

    useEffect(() => {
        if(navigationState.currentRoute !== FUNCTION)
            navigationState.setCurrentRoute(FUNCTION)
    },[]);

    if(isLoading)
        return <TaskToApprovalListSkeleton />

    return (
        <TaskToApprovalList level={LEVEL} />
    )
}

export default ApproveDocuments;